import { useStores } from 'utility/hooks/useStores';
import { toJS } from 'mobx';
import {
  FlightsJourneyCriteriaInput,
  FlightsTravelerDetailsInput,
  FlightsSearchContextInput,
  FlightsSearchFilterValuesInput,
  FlightsSortOptionTypeInput,
  ShoppingContextInput,
  FlightsSearchPreferencesInput,
  SideSheetQueryContextInput
} from '__generated__/api';
import { FlightsSortAndFiltersInputs } from '@shared-ui/retail-search-tools-flights';

export const useSortAndFilterInput = (isFsrSideSheet?: boolean): FlightsSortAndFiltersInputs => {
  const { searchCriteriaStore } = useStores();

  const {
    flightsSearchContext,
    travelerDetails,
    journeyCriteria,
    searchFilterValuesList,
    sortOption,
    shoppingContext,
    searchPreferences
  } = searchCriteriaStore.searchCriteria;

  let filtersValuesList: FlightsSearchFilterValuesInput[];
  let flightsSearchContextObj: FlightsSearchContextInput;
  let sideSheetQueryContext: SideSheetQueryContextInput;

  if (isFsrSideSheet) {
    filtersValuesList = toJS(
      searchCriteriaStore.dialogSideSheet.searchFilterValuesList
    ) as FlightsSearchFilterValuesInput[];
    flightsSearchContextObj = {
      tripType: flightsSearchContext.tripType,
      journeysContinuationId: flightsSearchContext.journeysContinuationId,
      originalBookingId: flightsSearchContext.originalBookingId
    };
    sideSheetQueryContext = {
      addOnRequested: [],
      journeyContinuationId: searchCriteriaStore.sideSheetQueryContext.journeyContinuationId,
      isFirstLoad: false
    };
  } else {
    filtersValuesList = toJS(searchFilterValuesList) as FlightsSearchFilterValuesInput[];
    flightsSearchContextObj = toJS(flightsSearchContext) as FlightsSearchContextInput;
  }

  return {
    flightsSearchContext: flightsSearchContextObj,
    journeyCriteria: toJS(journeyCriteria) as FlightsJourneyCriteriaInput[],
    travelerDetails: toJS(travelerDetails) as FlightsTravelerDetailsInput[],
    searchFilterValuesList: filtersValuesList,
    sortOption: toJS(sortOption) as FlightsSortOptionTypeInput,
    shoppingContext: toJS(shoppingContext) as ShoppingContextInput,
    searchPreferences: toJS(searchPreferences) as FlightsSearchPreferencesInput,
    sideSheetQueryContext: sideSheetQueryContext
  };
};
